module.exports = "../../app/cells/components/campaigns/interventions/sessions_side_hero/show.erb";